export default __webpack_public_path__ + "static/media/icn-curve2.cb37fe36.svg";